import { symbol } from 'piconetworks/pkg-currency'

const priceText = (price, optionCurrency = 'USD', showCurrencyCode = true) => optionCurrency === 'USD'
    ? `${symbol(optionCurrency)}${price} ${optionCurrency}`
    : showCurrencyCode
        ? `${price} ${symbol(optionCurrency)} ${optionCurrency}`
        : price

export default priceText
